export default __webpack_public_path__ + "static/media/AddPolicy.fdb5da9d.svg";